import bem from './bem'
import { KEY_COMPONENT_NAME } from '../util/util'
export default function(component) {
  component.name = KEY_COMPONENT_NAME + component.name
  component.mixins = component.mixins || []
  component.mixins.push(bem)
  return component
}
